import * as React from "react";
import {
    List, 
    SimpleShowLayout,
    Datagrid, 
    Show,
    Filter,
    TextField, 
    RichTextField,
    TextInput,
    SelectArrayInput,
    ReferenceArrayInput,
    ReferenceInput,
    SelectInput,
    TopToolbar,
    ExportButton,
    ReferenceField,
    ReferenceArrayField,
    SingleFieldList,
    ChipField,
    UrlField,
    ImageField,
    FunctionField
} from 'react-admin';
import { Grid } from '@mui/material';
import { BulkDeleteButton } from 'react-admin';
import { JsonField } from "react-admin-json-view";
import Breadcrumb from '../components/breadcrumb';
import SyncButton from "../components/syncButton";
import PostShowActions from "../components/postShowActions";

const BulkActionButtons = props => (
    <BulkDeleteButton {...props} />
)

const ListActions = () => {
    return (
      <TopToolbar>
        <ExportButton />
        <SyncButton resource="posts" />
      </TopToolbar>
    );
  };

export const PostList = () => {
    return (
        <Grid container spacing={2}>
            <Breadcrumb title={ 'Posts' } />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <List empty={ false } filters={<PostFilter />} actions={ <ListActions />} title="Post" bulkActionButtons={<BulkActionButtons />}>
                        <Datagrid rowClick="show">
                            <TextField source="post_id" />
                            <RichTextField source="title" />
                            <UrlField source="link" />
                            <ReferenceArrayField label="Categories" reference="terms" source="categories" link="show">
                                <SingleFieldList>
                                    <ChipField source="name" color="secondary" />
                                </SingleFieldList>
                            </ReferenceArrayField>
                            <ReferenceArrayField label="Tags" reference="terms" source="tags" link="show">
                                <SingleFieldList>
                                    <ChipField source="name" color="secondary" />
                                </SingleFieldList>
                            </ReferenceArrayField>
                            <ReferenceField source="status" reference="post-status">
                                <FunctionField label="Status" render={
                                    record => record.id === 'publish' ? 
                                        (<ChipField source="title" color="primary" />) : (<ChipField source="title" color="default" />) 
                                } />
                            </ReferenceField>
                        </Datagrid>
                    </List>
                </Grid>
            </Grid>
        </Grid>
    );
}

export const PostShow = (props) => (
    <Show {...props} actions={<PostShowActions resource="posts" isEdit={false} />}>
        <Grid container paddingBottom={2} spacing={2}>
            <Grid item xs={8}>
                <SimpleShowLayout>
                    <TextField source="id" />
                    <RichTextField source="title" />
                    <UrlField source="link" />
                    <RichTextField source="slug" />
                    <ReferenceField source="status" reference="post-status">
                        <FunctionField label="Status" render={
                            record => record.id === 'publish' ? 
                                (<ChipField source="title" color="primary" />) : (<ChipField source="title" color="default" />) 
                        } />
                    </ReferenceField>
                </SimpleShowLayout>
            </Grid>
            <Grid item xs={4}>
                <SimpleShowLayout>
                    <ReferenceField source="featured_media" reference="media">
                        <ImageField source="source_url" title="Featured" emptyText="No Image" />
                    </ReferenceField>
                </SimpleShowLayout>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <SimpleShowLayout>
                            <ReferenceArrayField label="Categories" reference="terms" source="categories" link="show">
                                <SingleFieldList>
                                    <ChipField source="name" color="secondary" />
                                </SingleFieldList>
                            </ReferenceArrayField>
                        </SimpleShowLayout>
                    </Grid>
                    <Grid item xs={6}>
                        <SimpleShowLayout>
                            <ReferenceArrayField label="Tags" reference="terms" source="tags" link="show">
                                <SingleFieldList>
                                    <ChipField source="name" color="secondary" />
                                </SingleFieldList>
                            </ReferenceArrayField>
                        </SimpleShowLayout>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <SimpleShowLayout>
                    <RichTextField source="except" />
                </SimpleShowLayout>
            </Grid>
            <Grid item xs={12}>
                <SimpleShowLayout>
                    <RichTextField source="content" />
                </SimpleShowLayout>
            </Grid>
            <Grid item xs={6}>
                <SimpleShowLayout>
                    <JsonField 
                        source="meta" 
                        reactJsonOptions={{
                            collapsed: true,
                        }}
                    />
                </SimpleShowLayout>
            </Grid>
            <Grid item xs={6}>
                <SimpleShowLayout>
                    <JsonField 
                        source="_links" 
                        label="Links" 
                        reactJsonOptions={{
                            collapsed: true,
                        }}
                    />
                </SimpleShowLayout>
            </Grid>
            
        </Grid>
    </Show>
);

export const PostFilter= props => (
    <Filter { ...props }>
        <TextInput label="Search" source="keyword" alwaysOn />
        <ReferenceArrayInput alwaysOn source="categories" reference="terms" filter={{ taxonomy: 'category' }}>
            <SelectArrayInput />
        </ReferenceArrayInput>
        <ReferenceArrayInput alwaysOn source="tags" reference="terms" filter={{ taxonomy: 'post_tag' }}>
            <SelectArrayInput />
        </ReferenceArrayInput>
        <ReferenceInput alwaysOn source="status" reference="post-status">
            <SelectInput optionText="title" optionValue="id" fullWidth />
        </ReferenceInput>
    </Filter >
);
